import { useState, useRef } from 'react';
import { setLocalStorageValue } from '@Components/Utilities/CookieHelper';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Avatar from '@mui/material/Avatar'
import { styled } from '@mui/material/styles';
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const AppButton = styled(Link)(({ theme }) => ({
    display: 'block',
    fontWeight: '700',
    textDecoration: 'none',
    color: theme.palette.primary.contrastText,
    fontSize: '12px'
}));

const AppBanner = (props) => {
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const siteName = currentSite?.Site?.IsBidcaller ? "EquipmentFacts" : currentSite.CurrentSite;
    const [bannerClosed, setBannerClosed] = useState(true);
    const windowSize = useWindowSize();

    useEffect(() => {
        let dayMilliseconds = 1000 * 60 * 60 * 24;
        if (!localStorage.getItem('appBannerClosed') || (((new Date().getTime() / dayMilliseconds) - (new Date(localStorage.getItem('appBannerClosed')).getTime() / dayMilliseconds)) >= 1)) {
            setBannerClosed(false);
        }
    }, []);

    const closeBanner = () => {
        setLocalStorageValue('appBannerClosed', new Date());
        setBannerClosed(true);
    }

    return (
        <>
            {!bannerClosed &&
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#f5f5f5',
                    padding: '5px 0px',
                    boxShadow: 'inset 0px -5px 15px 0px rgba(0, 0, 0, 0.05)',
                    fontSize: windowSize.width <= 400 ? '12px' : '1em',
                    height: '60px'
                }}>
                    <Button onClick={closeBanner}
                        sx={{
                        '&:hover': { opacity: '1' },
                        padding: '10px',
                        opacity: '0.75',
                        backgroundColor: 'transparent',
                        border: 'none', 
                        boxShadow: 'none', 
                        'aria-label': translator.translate('sandhills.closepage'),
                        title: translator.translate('sandhills.closepage'),
                    }}>
                        <CloseIcon sx={{
                            fontSize: '16px',
                            color: 'black'
                        }} />
                    </Button>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: '0',
                        background: '#fff',
                        width: '50px',
                        height: '50px',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '10px'
                    }}>
                        <Link href={props.AppDownloadLink} target="_blank" aria-label={"Download " + siteName + " App (" + translator.translate('sandhills.opensinanewtab') + ")"} sx={{
                            borderRadius: '10px'
                        }}>
                            <Avatar src={props.AppLogo} alt={`${siteName} App Logo`} aria-hidden='true' sx={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '10px'
                            }}></Avatar>
                        </Link>
                    </Box>
                    <Box sx={{
                        flex: '1',
                        padding: '0 5px',
                        lineHeight: '1.25',
                        color: 'black',
                        fontSize: windowSize.width <= 400 ? '12px' : '1em',
                    }}>
                        <Typography sx={{
                            display: 'block',
                            fontSize: windowSize.width <= 400 ? '12px' : '1em',
                        }}><strong>{siteName}</strong></Typography>
                        <Typography sx={{ fontSize: windowSize.width <= 400 ? '12px' : '1em' }}>{props.IsAppleDevice ? <TranslationText tKey='sandhills.forapple' /> : <TranslationText tKey='sandhills.forandroid' />}</Typography>
                    </Box>
                    <Box sx={{
                        display: 'flex',
                        flexShrink: '0',
                        padding: '0 20px 0 0'
                    }}>
                        <AppButton sx={{
                            opacity: '0.75',
                            color: 'black',
                            padding: windowSize.width <= 400 ? '10px' : windowSize.width <= 480 ? '10px 5px' : '10px 10px'
                        }} href={props.AppDownloadLink} target="_blank"><TranslationText tKey='sandhills.open' /></AppButton>
                        <AppButton sx={{
                            background: (theme) => theme.palette.primary.main,
                            borderRadius: '5px',
                            padding: '10px 20px',
                        }} href={props.AppDownloadLink} target="_blank"><TranslationText tKey='sandhills.installapp' /></AppButton>
                    </Box>
                </Box>
            }
        </>
    );
}

export default AppBanner;
